import { useEffect, useCallback, useState } from "react";
import { useActions } from "../useActions";
import { useSelector } from "react-redux";
import { RootState } from "../../state/store";
import { useTypedSelector } from "../useTypedSelector";

function usePushbackLoans(loanStartDate: string) {

    const { getPushbackLoansData } = useActions();
    const accessToken = useSelector((state: RootState) => state.appSlice.accessToken);
    const configId = useSelector((state: RootState) => state.appSlice.configId);
    const { data, error, loading } = useTypedSelector((state) => state.pushbackLoans);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const fetchData = useCallback(() => {
        if (configId) {
            getPushbackLoansData(configId, accessToken, loanStartDate); // Access token not required since proxy will generate if needed locally
        }
    }, [getPushbackLoansData, accessToken, loanStartDate, configId]);

    const refresh = useCallback(() => {
        setRefreshTrigger(prev => prev + 1);
    }, []);

    useEffect(() => {
        if (loanStartDate) {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loanStartDate, refreshTrigger]);

    return { data, loading, error, refresh };
}
export { usePushbackLoans };